import type { Locale } from "@/config/locale.constants";

export const localeNames: Record<Locale, Record<Locale, string>> = {
    fa: {
        fa: "پارسی",
        en: "Persian",
        de: "Persisch",
    },
    en: {
        fa: "انگلیسی",
        en: "English",
        de: "Englisch",
    },
    de: {
        fa: "آلمانی",
        en: "German",
        de: "Deutsch",
    },
};

/**
 * The name of a language returns the target language (displayLocale).
 * For example: getLocaleName('fa', 'de') → "Persisch"
 */
export function getLocaleName(locale: Locale, displayLocale: Locale): string {
    return localeNames[locale][displayLocale];
}
